"use strict";

var _AppHeader, _SimpleAppHeader;
import { ContactNumbersProvider } from '@autoguru/components';
import { useDataDogRouteTracking } from '@autoguru/logs/datadog';
import { isAutoGuruSlug } from '@autoguru/mygarage-check-slug';
import { Portal, StickyBox } from '@autoguru/overdrive';
import { useLocation, useParams } from 'react-router-dom';
import { AppHeader, SimpleAppHeader, pageHeaderPortalId } from '~/src/components';
import { jsx as _jsx } from "react/jsx-runtime";
export const App = () => {
  const {
    slug
  } = useParams();
  const isAutoGuru = isAutoGuruSlug(slug);
  const location = useLocation();
  useDataDogRouteTracking(location);
  return /*#__PURE__*/_jsx(ContactNumbersProvider, {
    children: /*#__PURE__*/_jsx(Portal, {
      container: document.querySelector(`#${pageHeaderPortalId}`),
      children: /*#__PURE__*/_jsx(StickyBox, {
        top: "none",
        zIndex: 1,
        children: isAutoGuru ? _AppHeader || (_AppHeader = /*#__PURE__*/_jsx(AppHeader, {})) : _SimpleAppHeader || (_SimpleAppHeader = /*#__PURE__*/_jsx(SimpleAppHeader, {}))
      })
    })
  });
};